import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 3 años sin dormir bien. La primera noche que hice el protocolo de contraste, dormí 6 horas seguidas. Lloré de alivio.',
  name: 'María G.',
  location: 'Houston, TX'
}, {
  quote: 'Mi doctor nunca me dijo que la Metformina me quitaba la B12. Este libro me abrió los ojos. La diferencia es enorme.',
  name: 'Roberto M.',
  location: 'Los Angeles, CA'
}, {
  quote: 'El mapa de inspección me salvó. Encontré una ampolla que no sentía. Mi podólogo dijo que llegué justo a tiempo.',
  name: 'Carmen L.',
  location: 'Miami, FL'
}];
export function TestimonialsSection() {
  return <section className="py-20 lg:py-28 bg-white" data-id="element-230">
      <div className="max-w-6xl mx-auto px-5 sm:px-8" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-232">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal mb-4" data-id="element-233">
            Lo Que Dicen Quienes Ya Siguen el Protocolo
          </h2>
          <div className="w-20 h-1 bg-gold-brand mx-auto rounded-full mb-3" data-id="element-234" />
          <p className="text-base text-gray-400 italic font-body" data-id="element-235">
            Resultados representativos de lectores que aplicaron la guía.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7" data-id="element-236">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream p-7 rounded-2xl shadow-sm border border-gold-brand/20 flex flex-col" data-id="element-237">
              <div className="flex gap-0.5 mb-5" data-id="element-238">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 fill-gold-brand text-gold-brand" data-id="element-239" />)}
              </div>
              <p className="text-lg font-body text-charcoal italic mb-6 flex-grow leading-relaxed" data-id="element-240">
                "{t.quote}"
              </p>
              <div className="border-t border-gray-200 pt-4 mt-auto" data-id="element-241">
                <p className="font-heading font-bold text-lg text-emerald-dark" data-id="element-242">
                  {t.name}
                </p>
                <p className="text-gray-500 font-body text-sm" data-id="element-243">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}